import { useLocale } from '../context/LocaleContext';

export default function LanguageSwitch() {
  const { locale, setLocale, t } = useLocale();

  return (
    <div className="desk-lang" role="group" aria-label={t('common.language')}>
      <span className={`desk-lang-thumb locale-${locale}`} aria-hidden="true" />
      <button
        type="button"
        className={locale === 'en' ? 'on' : ''}
        aria-pressed={locale === 'en'}
        onClick={() => setLocale('en')}
      >
        EN
      </button>
      <button
        type="button"
        lang="ar"
        className={locale === 'ar' ? 'on' : ''}
        aria-pressed={locale === 'ar'}
        onClick={() => setLocale('ar')}
      >
        عربي
      </button>
    </div>
  );
}
